import { render, staticRenderFns } from "@/style-guide/partials/input/input.pug?vue&type=template&id=1894a67f&scoped=true&lang=pug&external"
import script from "./input.vue?vue&type=script&lang=ts"
export * from "./input.vue?vue&type=script&lang=ts"
import style0 from "./input.vue?vue&type=style&index=0&id=1894a67f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894a67f",
  null
  
)

export default component.exports